import React from "react";
import { DOCUMENT_SECTIONS } from "../utils/documentSections";

const DocumentSectionTabs = ({ activeSection, onChange }) => (
  <div className="flex flex-wrap gap-2 mb-4 border-b pb-3">
    {[{ value: "all", label: "All" }, ...DOCUMENT_SECTIONS.map((section) => ({ value: section, label: section }))].map((tab) => (
      <button
        key={tab.value}
        type="button"
        onClick={() => onChange(tab.value)}
        className={`px-3 py-2 rounded text-xs font-semibold ${activeSection === tab.value ? "bg-blue text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"}`}
      >
        {tab.label}
      </button>
    ))}
  </div>
);

export default DocumentSectionTabs;
